import { useEffect } from "react";

/**
 * Custom hook to warn users before closing/refreshing the browser tab while recording
 * @param isRecording - Whether a recording is currently active
 */
export const useRecordingWarning = (isRecording: boolean) => {
  useEffect(() => {
    if (!isRecording) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Modern browsers require both preventDefault and returnValue
      e.preventDefault();
      e.returnValue = ""; // Chrome requires this to be set
      
      // Some browsers show a custom message (though most modern browsers ignore it)
      return "הקלטה פעילה. האם אתה בטוח שברצונך לעזוב?";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isRecording]);
};

